import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template7 = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-white min-h-screen font-sans">
            <header className="bg-white shadow-sm p-4 relative z-10">
                <div className="container mx-auto flex justify-between items-center">
                    <button
                        onClick={() => navigate('/TemplateThemes')}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                    >
                        <ArrowLeft size={18} /> Back to Templates
                    </button>
                    <h1 className="text-4xl font-light text-center tracking-widest text-gray-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>VOGUE</h1>
                    <div className="w-24"></div> {/* Placeholder for alignment */}
                </div>
            </header>
            
            <main className="min-h-screen">
                {/* Hero Section - Replicated from DesignerPage7 */}
                <section className="relative h-[60vh] md:h-[80vh] w-full">
                    <div className="absolute inset-0 bg-black/30 z-10"></div>
                    <img 
                        src="https://placehold.co/1920x1080/444444/FFFFFF?text=Designer+Collection" 
                        alt="Hero Banner" 
                        className="w-full h-full object-cover" 
                    />
                    <div className="absolute inset-0 z-20 flex items-center justify-center lg:justify-start">
                        <div className="w-full max-w-md bg-white/90 backdrop-blur-sm p-8 m-4 lg:ml-20 rounded-lg shadow-2xl text-center lg:text-left">
                            <h1 className="text-5xl font-bold tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Designer Name</h1>
                            <p className="mt-2 text-gray-600 leading-relaxed max-w-xs mx-auto lg:mx-0">
                                An exclusive collection of finely crafted designs.
                            </p>
                            <nav className="mt-6 flex flex-wrap justify-center lg:justify-start gap-2">
                                <a href="#" className="px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 bg-gray-900 text-white">All</a>
                                <a href="#" className="px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 bg-gray-200 text-gray-800 hover:bg-gray-300">Indianwear</a>
                                <a href="#" className="px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 bg-gray-200 text-gray-800 hover:bg-gray-300">Westernwear</a>
                                <a href="#" className="px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 bg-gray-200 text-gray-800 hover:bg-gray-300">Dresses</a>
                            </nav>
                        </div>
                    </div>
                </section>

                {/* Category Grid Section - Replicated from DesignerPage7 */}
                <div className="container mx-auto px-4 md:px-8 py-16">
                    <section className="mb-16">
                        <div className="text-center mb-8">
                            <h2 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Shop by Category</h2>
                            <p className="text-gray-500 mt-1">Discover curated looks for every occasion.</p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[1, 2, 3, 4].map((id) => (
                                <div key={id} className="group relative rounded-lg overflow-hidden cursor-pointer aspect-w-4 aspect-h-5">
                                    <img 
                                        src={`https://placehold.co/400x500/E0E0E0/333333?text=Category+${id}`} 
                                        alt={`Category ${id}`} 
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" 
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent"></div>
                                    <div className="absolute bottom-0 left-0 p-4 text-white">
                                        <h3 className="text-xl font-bold">Category {id}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Product Gallery Section - Replicated from DesignerPage7 */}
                    <main>
                        <div className="flex justify-between items-center mb-8">
                            <h2 className="text-3xl font-bold tracking-tight capitalize" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                The Collection
                            </h2>
                            <span className="text-sm text-gray-500 font-medium bg-gray-100 px-3 py-1 rounded-full">12 Shown</span>
                        </div>
                        
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                            {[1, 2, 3, 4, 5, 6, 7, 8].map(id => (
                                <div key={id} className="bg-white p-4 rounded-lg shadow-sm">
                                    <img src={`https://placehold.co/400x500/F0F0F0/333333?text=Product+${id}`} alt={`Product ${id}`} className="w-full h-64 object-cover rounded-md mb-4" />
                                    <h3 className="font-semibold text-gray-800 text-lg">Product Title {id}</h3>
                                    <p className="text-gray-600 mt-1">$XX.XX</p>
                                    <button className="mt-3 w-full px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors">Add to Cart</button>
                                </div>
                            ))}
                        </div>
                    </main>
                </div>
            </main>
            <footer className="bg-gray-900 text-white text-center p-6 mt-8">
                <p>&copy; 2025 Vogue. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Template7;